import React from 'react';

import { Card } from 'antd';

import type IProduct from 'interfaces/IProduct';
import type { ICheckoutsUrls } from 'scenes/Producer/MyCampaigns';

import AdvancedConfigsUrls from './AdvancedConfigsUrls';
import Atention from './Atention';
import CheckoutLink from './CheckoutLink';
import CheckoutSunLink from './CheckoutSunLink';

interface IProps {
  currentProduct: IProduct;
  currentUserId: number;
  physicalProductPending: boolean;
  openUrlCreatorCheckout: (urls: ICheckoutsUrls) => void;
  openTrackerForm: () => void;
}

const CheckoutUrls = ({
  currentProduct,
  currentUserId,
  physicalProductPending,
  openUrlCreatorCheckout,
  openTrackerForm
}: IProps) => {
  return (
    <Card>
      <div className='flex flex-col gap-6'>
        <CheckoutLink
          currentProduct={currentProduct}
          currentUserId={currentUserId}
          physicalProductPending={physicalProductPending}
        />
        {!currentProduct.show_only_checkout_sun_v4 && (
          <CheckoutSunLink
            currentProduct={currentProduct}
            currentUserId={currentUserId}
            physicalProductPending={physicalProductPending}
          />
        )}
        <AdvancedConfigsUrls
          currentProduct={currentProduct}
          openTrackerForm={openTrackerForm}
          openUrlCreatorCheckout={openUrlCreatorCheckout}
        />
        <Atention />
      </div>
    </Card>
  );
};

export default CheckoutUrls;
